<template>
  <div v-bind:class="{ dark: isDark }">
    <div
      class="
        flex
        antialiased
        text-gray-900
        dark:bg-dark
        dark:text-light
        mt-8
        sm:mt-5
        border-t-2
        border-neutral-400
      "
    >
      <!-- Loading screen -->


      <!-- Sidebar -->
      <!-- Backdrop -->
      <aside
        ref="sidebar"
        v-on:keydown.escape="
          window.innerWidth <= 1024 ? (isSidebarOpen = false) : ''
        "
        tabindex="-1"
        class="
          inset-y-0
          z-10
          flex
          flev-shrink-0
          overflow-hidden
          lg:static
          dark:border-primary-800
          dark:bg-darker
          focus:outline-none
        "
      >
        <!-- Sidebar links -->
        <nav
          aria-label="Main"
          class="
            flev-1
            w-64
            pv-2
            py-4
            space-y-2
            overflow-y-hidden
            hover:overflow-y-auto
          "
        >
          <!-- Dashboards links -->
          <nav-entry
            icon="fas fa-tachometer-alt"
            text="Dashboard"
            v-bind:href="route('home')"
        ></nav-entry>

          <!-- Dashboards links -->
          <nav-entry
            icon="fa-user"
            text="Utenti"
            v-bind:items="[
              { text: 'Gestisci utenti', href: route('users.browse') },
              { text: 'Crea nuovo', href: route('users.new') },
            ]"
          ></nav-entry>

          <!-- Interventions links -->
          <nav-entry
            icon="fa-edit"
            text="Interventi"
            v-bind:items="[
              {
                text: 'Gestisci interventi',
                href: route('interventions.browse'),
              },
              { text: 'Crea nuovo', href: route('interventions.new') },
            ]"
          ></nav-entry>

          <!-- Clients links -->
          <nav-entry
            icon="far fa-id-card"
            text="Clienti"
            v-bind:items="[
              {
                text: 'Gestisci clienti',
                href: route('clients.browse'),
              },
              { text: 'Crea nuovo', href: route('clients.new') },
            ]"
          ></nav-entry>
        </nav>
      </aside>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDark: false,
      isNotificationsPanelOpen: false,
      isSettingsPanelOpen: false,
      isSearchPanelOpen: false
    };
  },

  methods: {
    toggleSidbarMenu() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    openNotificationsPanel() {
      this.isNotificationsPanelOpen = true;
      this.$nextTick(() => {
        this.$refs.notificationsPanel.focus();
      });
    },
    openSettingsPanel() {
      this.isSettingsPanelOpen = true;
      this.$nextTick(() => {
        this.$refs.settingsPanel.focus();
      });
    },
    openSearchPanel() {
      this.isSearchPanelOpen = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
  },
};
</script>
